/* @flow */
import * as React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';

import {
  RequestInAppBlock,
  ReviewBlock,
  ThreeFeaturesBlock,
  PreparingForYourMoveBlock,
} from '../components';
import { BodyText, Container, SectionTitle, Spacer } from '../../components/core';
import { PageBody } from '../../components/chrome';
import Reviews, { getReviewTagged } from '../../../data/Reviews';
import { ResponsiveEstimateForm } from '../../components/EstimateForm';
import type { ServicesPageChromeMetadata } from './ServicesPageChrome';
import tripRequests from '../../../redux/trip-requests';
import type { UseCase } from '../../../data/TripRequests';
import PublicStorageBlock from '../components/PublicStorageBlock';

class StorageMovesPage extends React.Component<{
  setNewTripRequestUseCase: (useCase: UseCase) => void,
}> {
  static metadata = {
    title: 'Storage Moves',
    description:
      'Same day storage movers to pickup and deliver anything in and out of your storage unit. Learn how to get affordable moving & delivery to and from U-Haul Storage, Extra space storage, Public Storage, Self Storage, Clutter and more.',
  };

  static servicesMetadata: ServicesPageChromeMetadata = {
    illustration: 'moving-into-storage',
    id: 'storage-moves',
  };

  componentDidMount() {
    const { setNewTripRequestUseCase } = this.props;
    setNewTripRequestUseCase('storage');
  }

  render() {
    return (
      <PageBody>
        <Container padded={true} align="center">
          <SectionTitle title="Pick up and delivery to and from storage" />
          <BodyText
            size="16"
            align="center"
            style={{ maxWidth: 630, marginLeft: 'auto', marginRight: 'auto' }}>
            Effortlessly move your belongings in and out of your storage unit. Store your things
            with a tap and have them back in as little as an hour when you need them.
          </BodyText>
          <Spacer size={80} />
          <ThreeFeaturesBlock
            features={[
              {
                title: 'Store anywhere',
                description:
                  "Store your belongings at your nearest storage unit or your parents garage. We'll load, haul, and deliver anything, anywhere.",
                icon: 'storage-alt1',
              },
              {
                title: 'Convenient access',
                description:
                  'Your storage unit and everything in it just a tap away. Picked up and delivered in under an hour.',
                icon: 'stay-at-home',
              },
              {
                title: 'Your things protected',
                description:
                  'Your Lugg will be backed by our multi-million dollar insurance policy from the moment your items are in our hands.',
                icon: 'shield',
              },
            ]}
          />
        </Container>
        <Spacer size={120} />
        <Container size="large" padded={true}>
          <ResponsiveEstimateForm />
        </Container>
        <Spacer size={120} />
        <PublicStorageBlock />
        <Spacer size={120} />
        <Container padded={true}>
          <RequestInAppBlock title="Scheduled through the app" />
        </Container>
        <Spacer size={140} />
        <PreparingForYourMoveBlock />
        <Spacer size={120} />
        <Container padded={true}>
          <ReviewBlock review={getReviewTagged(Reviews, 'storage-page')} />
        </Container>
      </PageBody>
    );
  }
}

export default compose(
  connect(
    null,
    dispatch => ({
      setNewTripRequestUseCase: useCase =>
        dispatch(tripRequests.actions.setNewTripRequestUseCase(useCase)),
    })
  )
)(StorageMovesPage);



// WEBPACK FOOTER //
// ./src/ui/pages/ServicesPage/StorageMovesPage.js